<nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white px-5" style="height: 72px; z-index: 10;">
    <a class="navbar-brand mr-0" routerLink="/home">
        <img src="assets/img/Logotipo-07.png" height="30" alt="" class="logo-desktop">
        <img src="assets/img/Logotipo-09.png" height="30" alt="" class="logo-mobile">
    </a>

    <div style="border-right: 1px solid #C7C7C7; height: 30px; margin: 0px 15px;"></div>

    <div class="flex items-center gap-2">

        <img *ngIf="tenant.logo" [src]="tenant?.logoExists ? tenant?.logoPath : 'assets/img/noimage.png'"
            alt="{{ tenant.name }}" height="32" class="hidden sm:block object-contain tenant-desktop-img"/>

        <img *ngIf="tenant.logo_escudo" [src]="tenant?.logoEscudoExists ? tenant?.logoEscudoPath : 'assets/img/noimage.png'"
            alt="{{ tenant.name }}"  height="48" class="block sm:hidden object-contain tenant-mobile-img img-hide"/>

    </div>

    <ul class="ml-auto nav-responsive">
        <a class="nav-link" routerLink="**" style="padding: 0;">Inicio</a>

        <!-- <button mat-icon-button (click)="OpenModal()" matTooltip="Seleccionar empresa" matTooltipPosition="above">
            <mat-icon>business</mat-icon>
        </button> -->

        <li>
            <div style="border-right: 1px solid #C7C7C7; height: 30px; margin: 0px 19.5px;"></div>
        </li>
        <li class="nav-item dropdown" *ngIf="user;else noLogin">
            <a class="nav-link dropdown-toggle d-flex align-items-center" id="navbarDropdown" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding: 0;">
                <img [src]="user?.photoExists ? user?.photoPath : defaultUserImage" height="40" class="rounded-circle" style="cursor: pointer;">
                <p class="m-0 pl-2 xs-hide" style="cursor: pointer;">{{user.name}}</p>
            </a>
            <div class="dropdown-menu dropdown-menu-right mt-2" aria-labelledby="navbarDropdown">
                <p class="dropdown-item" (click)="profile()" style="cursor: pointer;">Mi perfil</p>
                <!-- <p class="dropdown-item" (click)="OpenModal()" style="cursor: pointer;">Cambiar empresa</p> -->
                <button class="dropdown-item" (click)="logout()">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                    Cerrar sesión
                </button>
            </div>
        </li>
        <ng-template #noLogin>
            <li class="nav-item xs-hide">
                <a class="nav-link" routerLink="/login">Iniciar sesión</a>
            </li>
        </ng-template>

    </ul>
</nav>
<!-- Modal personalizado -->
<!-- 
<ng-template #tenantDialog>
    <div class="modal-header">
        <h2 class="modal-title">Selecciona una empresa</h2>
        <button mat-icon-button class="close" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal-body">
        <ng-container *ngIf="filteredTenants.length > 0; else loading">
            <div class="form-group">
                <label for="tenantSelect">Empresa <span style="color: #FF3333;"><b>*</b></span></label>
                <input *ngIf="user.tenant_id; else allTenants" type="text" class="form-control" readonly
                    [value]="tenant?.name">
                    <div>{{user.tenant_id}}</div>
                <ng-template #allTenants>
                    <select class="form-control" id="tenantSelect" [ngClass]="{'is-invalid': !selectedTenant}"
                        [(ngModel)]="selectedTenant">
                        <option value="">Seleccione una empresa</option>
                        <option *ngFor="let tenant of filteredTenants" [value]="tenant.slug">
                            {{tenant.name}}
                        </option>
                    </select>
                </ng-template>
                <div class="invalid-tooltip">
                    Completa este campo.
                </div>
            </div>
        </ng-container>

        <ng-template #loading>
            <div class="flex justify-center p-4">
                <mat-spinner diameter="32"></mat-spinner>
            </div>
        </ng-template>
    </div>

    <mat-dialog-actions align="center" class="modal-actions">
        <button type="submit" mat-raised-button color="primary" [disabled]="!selectedTenant" (click)="confirmTenant()">
            Ingresar
        </button>
    </mat-dialog-actions>
</ng-template> -->